import api from "./../utils/api";

export const getUserLogin = async (userId, limit = 10, page = 1) => {
  try {
    const response = await api.get(
      `/interaction/user-login/${userId}?limit=${limit}&page=${page}`,
      {
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
